import React, { useState } from "react";
import ReactApexChart from "react-apexcharts";
import getChartColorsArray from "../../../Components/Common/ChartsDynamicColor";

const AverageSpending = ({ dataColors }) => {
  var areachartSplineColors = getChartColorsArray(dataColors);
  const [chartData] = useState({
    series: [
      {
        name: "Revenue",
        data: [31, 40, 28, 51, 42, 109, 100],
      },
    ],
    options: {
      chart: {
        type: "area",
        height: 350,
        toolbar: {
          show: false,
        },
      },
      colors: ["#0d6efd"], // Customize line color
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      colors: areachartSplineColors,
      xaxis: {
        type: "datetime",
        categories: [
          "2024-11-01",
          "2024-11-02",
          "2024-11-03",
          "2024-11-04",
          "2024-11-05",
          "2024-11-06",
          "2024-11-07",
        ],
      },
      tooltip: {
        x: {
          format: "dd MMM yyyy",
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.3,
          stops: [0, 90, 100],
        },
      },
    },
  });

  return (
    <React.Fragment>
      <ReactApexChart
        options={chartData.options}
        series={chartData.series}
        type="area"
        height={350}
      />
    </React.Fragment>
  );
};

const AverageVisit = ({ dataColors }) => {
  var linechartBasicColors = getChartColorsArray(dataColors);
  const [chartData] = useState({
    series: [
      {
        name: "visit",
        data: [31, 40, 28, 51, 42, 109, 100],
      },
    ],
    options: {
      chart: {
        type: "area",
        height: 350,
        toolbar: {
          show: false,
        },
      },
      colors: ["#0d6efd"], // Customize line color
      dataLabels: {
        enabled: false,
      },
      stroke: {
        curve: "smooth",
      },
      colors: linechartBasicColors,
      xaxis: {
        type: "year",
        categories: ["2018", "2019", "2020", "2021", "2022", "2023", "2024"],
      },
      tooltip: {
        x: {
          format: "dd MMM yyyy",
        },
      },
      fill: {
        type: "gradient",
        gradient: {
          shadeIntensity: 1,
          opacityFrom: 0.7,
          opacityTo: 0.3,
          stops: [0, 90, 100],
        },
      },
    },
  });
  return (
    <React.Fragment>
      <ReactApexChart
        options={chartData.options}
        series={chartData.series}
        type="area"
        height={250}
      />
    </React.Fragment>
  );
};

export { AverageSpending, AverageVisit };
